import { ContentState, convertToRaw } from "draft-js";

// ! https://github.com/facebook/draft-js/issues/2121
export const EMPTY_CONTENT_STATE = ContentState.createFromText("");

export const EMPTY_RAW_DRAFT_CONTENT_STATE = convertToRaw(EMPTY_CONTENT_STATE);
